var sizingsNative = {
  m: {
    height: 4
  },
  l: {
    height: 8
  }
};
var progressThemeNative = {
  // border radius will be taken from the provided theme
  color: 'primary',
  step: {
    color: 'border.disabled'
  },
  gap: 4,
  sizings: sizingsNative
};

export { progressThemeNative, sizingsNative };
